/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { headers, setupInterceptorsTo } from "./interceptors"
import { setData } from "../app/slices/patients/patientSlice"

const MEDIT_DATA_URL = "https://stage-openapi-resources.meditlink.com"
const { VITE_DOMAIN } = import.meta.env
import create7z from "7z-wasm";

class HttpMedit {
  private instance: AxiosInstance

  constructor() {
    this.instance = axios.create({
      timeout: 60000, // 设置超时时间，单位为毫秒
      // 可以在这里设置其他默认配置，如 headers
      //withCredentials: true,
    })
  }

  async get<T = any>(
    path: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    try {
      await this.updateTokenIfExpired()
      let jsonObj = JSON.parse(localStorage.getItem("meditData"))

      const response = await this.instance.get<T>(MEDIT_DATA_URL + path, {
        ...config,
        headers: {
          ...(config && config.headers),
          Authorization: `Bearer ${jsonObj.accessToken}`,
        },
      })
      return response
    } catch (error) {
      // 在这里处理错误，例如抛出自定义错误或返回默认值
      console.error("GET request failed:", error)
      throw error
    }
  }

  async post<T = any>(
    path: string, // 设置默认请求地址
    data: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    try {
      await this.updateTokenIfExpired()
      let jsonObj = JSON.parse(localStorage.getItem("meditData"))

      // 手动构建x-www-form-urlencoded格式字符串
      const formData = Object.entries(data)
        .map(([key, value]) => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        })
        .join("&")

      const response = await this.instance.post(
        MEDIT_DATA_URL + path,
        formData,
        {
          ...config,
          headers: {
            ...(config && config.headers),
            Authorization: `Bearer ${jsonObj.accessToken}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      return response
    } catch (error) {
      console.error("POST request failed:", error)
      throw error
    }
  }

  async postLogin<T = any>(
    path: string, // 设置默认请求地址
    data: string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<T>> {
    try {
      // 手动构建x-www-form-urlencoded格式字符串
      const formData = Object.entries(data)
        .map(([key, value]) => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        })
        .join("&")

      const authstr = btoa(
        "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo:EKjf3oIfyfyoSttGo4a017V1qsMsoe2p",
      )
      const response = await this.instance.post(path, formData, {
        ...config,
        headers: {
          ...(config && config.headers),
          Authorization: `Basic ${authstr}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      return response
    } catch (error) {
      console.error("POST request failed:", error)
      throw error
    }
  }

  async updateTokenIfExpired() {
    //console.log("token_data(3shape)=", localStorage.getItem("3shapeData"))
    let jsonObj = JSON.parse(localStorage.getItem("meditData"))

    const currentSeconds: number = Math.floor(new Date().getTime() / 1000)

    if (currentSeconds - jsonObj.lastTokenTime >= 33600) {
      console.log(
        "need refresh token , passed secs=",
        currentSeconds - jsonObj.lastTokenTime,
      )
      await medit_refreshToken()
    }
  }
  async download7z(url: string = "http://xxxxxx"): Promise<Blob | null> {
    const meditClient = new HttpMedit() // 设置基础URL
    const grpUuid = await getMeditGroupUuid()
    this.updateTokenIfExpired()

      try {
        const response = await fetch(url, {
          method: "GET", // 通常下载文件是 GET 请求
          headers: {
            "x-meditlink-client-id": "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo",
            "x-meditlink-group-uuid": `${grpUuid}`,
          },
        })

        // 检查响应状态码
        if (!response.ok) {
          // 如果响应不成功（例如 401 Unauthorized, 404 Not Found, 500 Internal Server Error）
          const errorText = await response.text() // 尝试获取错误信息
          console.error(
            `Failed to download blob file: ${response.status} ${response.statusText}`,
            errorText,
          )
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        // 获取 Blob 对象，适合文件下载
        const zipArray = await response.arrayBuffer()
        const { FS, callMain } = await create7z({
          locateFile: (path: string) => {
            if (path.endsWith(".wasm")) return "/7zz.wasm";
            return path;
          },
        }) as any;

        // 写入压缩包
        FS.writeFile("/input.7z", new Uint8Array(zipArray));

        // 创建输出目录（7z 会要求它存在）
        try {
          FS.mkdir("/output");
        } catch (e) {
          // 如果目录已存在，忽略错误
          console.log("Output directory already exists, ignoring error.");
        }

        // list 模拟（可省略）
        console.log("列出压缩包内容:");
        callMain(["l", "/input.7z"]); // 类似于终端的 `7z l input.7z`

        // 解压 stl（全部解压）
        console.log("解压中...");
        callMain(["x", "/input.7z", `-o/output`]);

        // 获取所有文件列表
        const stlFiles = FS.readdir("/output").filter(f => f.endsWith(".stl"));
        if (stlFiles.length === 0) {
          console.log("未找到 .stl 文件");
          return;
        }

        // 读取第一个 .stl 文件内容
        const stlContent = FS.readFile(`/output/${stlFiles[0]}`);
        const blob = new Blob([stlContent], { type: "application/octet-stream" });
        return blob
      } catch (error) {
        console.error("Error during download:", error)
        return null
      }
  }

  //可以添加其他的http方法例如：put, delete等。
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new HttpMedit()

export async function getMeditToken(code_: string) {
  const meditClient = new HttpMedit() // 设置基础URL

  try {
    // const getResponse = await shape3Client.get('/', {
    //   headers: {
    //     'Authorization': 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjM4RTg2MTA1RjJGRDNBNzkzOUMwODg4QzE4RjlCMUQwRTA3Q0EzQzVSUzI1NiIsIng1dCI6Ik9PaGhCZkw5T25rNXdJaU1HUG14ME9COG84VSIsInR5cCI6ImF0K2p3dCJ9.eyJpc3MiOiJodHRwczovL3N0YWdpbmctaWRlbnRpdHkuM3NoYXBlLmNvbSIsIm5iZiI6MTc0Mjg3MjA1NiwiaWF0IjoxNzQyODcyMDU2LCJleHAiOjE3NDI4NzU2NTYsImF1ZCI6WyJhcGkiLCJjb21tdW5pY2F0ZSIsImRhdGEiXSwic2NvcGUiOlsib3BlbmlkIiwiYXBpIiwiY29tbXVuaWNhdGUuY29ubmVjdGlvbnMubWFuYWdlIiwiZGF0YS5jb21wYW5pZXMucmVhZF9vbmx5IiwiZGF0YS51c2Vycy5yZWFkX29ubHkiLCJvZmZsaW5lX2FjY2VzcyJdLCJhbXIiOlsicHdkIl0sImNsaWVudF9pZCI6IlVsYWIuU3RhZ2luZyIsInJvbGUiOlsiU1RMQWNjZXNzIiwiTGFiIiwiRW1wbG95ZWUuQWRtaW5pc3RyYXRvciIsIkVtcGxveWVlLk93bmVyIiwiVXNlci5Db21wYW55LkFkbWluaXN0cmF0b3IiLCJVc2VyLkNvbXBhbnkuT3duZXIiXSwic3ViIjoiNWRhMzE3MjYtZmY2ZS00OWIyLTgyYTgtNTFjNjE1NjNkYzRjIiwiYXV0aF90aW1lIjoxNzQyODcyMDA5LCJpZHAiOiJsb2NhbCIsIm5hbWUiOiJyYXlAdWxhYnN5c3RlbXMuY29tIiwiZW1haWwiOiJyYXlAdWxhYnN5c3RlbXMuY29tIiwicHJlZmVycmVkX3VzZXJuYW1lIjoicmF5QHVsYWJzeXN0ZW1zLmNvbSIsImZpcnN0TmFtZSI6InJheSIsImxhc3ROYW1lIjoiTWEiLCJ2ZXJpZmllZCI6IlRydWUiLCJjb21wYW55SWQiOiI1YmE5OGRkYy1hZmE3LTRjNDEtOWVkNS0zZjgwYzJkNWJmZWMiLCJzZWxlY3RlZENvbXBhbnlJZCI6IjViYTk4ZGRjLWFmYTctNGM0MS05ZWQ1LTNmODBjMmQ1YmZlYyIsInJlZ2lvbklkIjoiMSIsInVzZXJfaXAiOiIxNzguMTU3LjYxLjIyOCIsInNpZCI6IjcxNEEyMjA3OUVCNTZEOTJBQzVCQUM2MTlFRTc1RkRFIn0.OfHf89w698E9doEVOEyxX3eCcPa2w3mb7JQIKaOvMSBNc0Rb2KU2wDygBbZTtu3dqw71H-X0c_WPJ-4TMuLeqv8tZm_GwN-Ch1GwKwwS2H2gbsiMCk-mGw9wJjsE3e0QF-mjn-ytQSwWE5FhzVU8EINmo1uLOlUD4kriqNIoeAaL9KoMm1yf1CcjP1j26whYoZsrLc0ZYGsGLN6HV2ZxBOpD1E8u8t9Rz9ZzkTWfZ9iyozUuceOCIrxMOrwBACXTDUAqP8ERfWWeuZZHeebizCT9D9mdSAENBXE73j4K_IRFhOWR3cbkDxXHYQp-NF-vP6pgu7eqDj1XO9U4GNomTg',
    //     'Custom-Header': 'custom_value',
    //   },
    // });
    // console.log('GET response data:', getResponse.data);

    const postResponse = await meditClient.postLogin(
      "https://stage-openapi-auth.meditlink.com/oauth/token",
      {
        code: code_,
        grant_type: "authorization_code",
        redirect_uri: `${VITE_DOMAIN}/settings/integrations?from=medit`,
        state: "bn6q6ru91ygkzwo8rfc0s1f7",
        scope: "USER GROUP CASE FILE ORDER",
      },
    )
    console.log("POST response data:", postResponse.data.access_token)

    const currentSeconds: number = Math.floor(new Date().getTime() / 1000)
    console.log("cur Unix timestamp:", currentSeconds)
    // 判断是否已有scanner被链接上了
    const shapeScanner = localStorage.getItem("3shapeData")
    const alliesScanner = localStorage.getItem("alliesData")
    localStorage.setItem(
      "meditData",
      JSON.stringify({
        accessToken: postResponse.data.access_token,
        refreshToken: postResponse.data.refresh_token,
        expireSecs: postResponse.data.expires_in,
        lastTokenTime: currentSeconds,
        isPrimary: !shapeScanner && !alliesScanner ? true : false,
      }),
    )
    return true
  } catch (error) {
    // 处理请求错误
    console.error("Request error:", error)
  }
}

export async function medit_refreshToken() {
  const meditClient = new HttpMedit() // 设置基础URL

  try {
    let jsonObj = JSON.parse(localStorage.getItem("meditData"))
    console.log("old refreshToken=", jsonObj.refreshToken)

    // const customHeaders = {
    //   'Authorization': `Bearer ${jsonObj.accessToken}`, // 例如，添加认证 Token
    //   // 'Content-Type': 'application/json' // 注意：你的方法内部会强制设置为 x-www-form-urlencoded，这里设置不同的 Content-Type 可能无效
    // };

    // // 构建完整的配置对象，包含 headers
    // const requestConfig: AxiosRequestConfig = {
    //     headers: customHeaders,
    //     // 还可以添加其他 Axios 配置，比如 timeout, params 等
    //     timeout: 5000
    // };

    const postResponse = await meditClient.postLogin(
      "https://stage-openapi-auth.meditlink.com/oauth/token",
      {
        grant_type: "refresh_token",
        refresh_token: jsonObj.refreshToken,
      },
    )
    console.log("refresh token data:", postResponse.data)

    const currentSeconds: number = Math.floor(new Date().getTime() / 1000)
    console.log("cur Unix timestamp:", currentSeconds)
    const meditObj = JSON.parse(localStorage.getItem("meditData"))
    localStorage.setItem(
      "meditData",
      JSON.stringify({
        accessToken: postResponse.data.access_token,
        refreshToken: postResponse.data.refresh_token,
        expireSecs: postResponse.data.expires_in,
        lastTokenTime: currentSeconds,
        isPrimary: meditObj.isPrimary,
      }),
    )
  } catch (error) {
    // 处理请求错误
    console.error("Request error:", error)
  }
}

export async function getMeditGroupUuid() {
  const meditClient = new HttpMedit() // 设置基础URL
  

  let jsonObj = JSON.parse(localStorage.getItem("meditData"))
  if(jsonObj.groupUuid) {
    console.log("found uuid ,return")
    return jsonObj.groupUuid
  }

  try {
    const getResponse = await meditClient.get("/v1/me?schema=latest", {
      headers: {
        "x-meditlink-client-id": "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo",
        "Content-Type": "application/json",
      },
    })
    console.log("get /me  data:", getResponse)

    jsonObj['groupUuid'] = getResponse.data.group.uuid

    localStorage.setItem(
      "meditData",
      JSON.stringify(jsonObj),
    )

    return getResponse.data.group.uuid
    //localStorage.setItem("meditData",JSON.stringify({accessToken:postResponse.data.access_token, refreshToken: postResponse.data.refresh_token,  expireSecs:postResponse.data.expires_in, lastTokenTime:currentSeconds}))
  } catch (error) {
    // 处理请求错误
    console.error("Request error:", error)
  }
}

interface DataItem {
  Attachments: any[]
  Scans: any[]
  Info: {
    CaseId: string
    PatientName: string
    CreateTime: string
    FirstName: string
    LastName: string
  } //Record<string, unknown>;
}

function splitAtFirstSpace(str: string): string[] {
  // 1. 判断字符串中是否有空格
  const hasSpace = str.includes(" ")

  if (hasSpace) {
    // 2. 如果有空格，使用 indexOf 找到第一个空格的位置
    const firstSpaceIndex = str.indexOf(" ")

    // 3. 使用 slice 或 substring 按照第一个空格切分
    // slice(startIndex, endIndex) 截取从 startIndex 到 endIndex-1 的部分
    // slice(startIndex) 截取从 startIndex 到字符串末尾的部分
    const part1 = str.slice(0, firstSpaceIndex)
    const part2 = str.slice(firstSpaceIndex + 1) // +1 跳过空格本身

    return [part1, part2]
  } else {
    const hasPoint = str.includes(".")

    if (hasPoint) {
      const firstSpaceIndex = str.indexOf(".")
      const part1 = str.slice(0, firstSpaceIndex)
      const part2 = str.slice(firstSpaceIndex + 1) // +1 跳过空格本身

      return [part1, part2]
    } else {
      // 4. 如果没有空格，返回包含原字符串的单个元素的数组
      return [str, str]
    }
  }
}

export async function getMeditCaselist(
  page: number = 0, 
  size: number = 10, 
  name: string = "",
  start: number = 0,
  end: number = 253402300799000,
  status: string = "",
  patientCode: string = ""
) {
  // get group-uuid from /me?schema=latest  api
  const grpUuid = await getMeditGroupUuid()

  const meditClient = new HttpMedit() // 设置基础URL
  let caselist: any[] = []

  try {
    const getResponse = await meditClient.get(`/v1/cases/search?schema=latest&size=${size}&page=${page}&start=${start}&end=${end}&name=${name}&status=${status}&patientCode=${patientCode}`, {
      headers: {
        "x-meditlink-client-id": "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo",
        "x-meditlink-group-uuid": `${grpUuid}`,
      },
    })
    console.log("GET response data:", getResponse.data)

    if (getResponse.data){
      caselist = getResponse.data.content
      const result: DataItem[] = caselist.map((item: any) => {
        const namesArray = splitAtFirstSpace(item.name)
        return {
          Attachments: item.Attachments || [],
          Scans: item.Scans || [],
          Info: {
            CaseId: item.uuid, // 示例字段
            PatientName: item.name,
            CreateTime: item.dateCreated,
            LastName: namesArray[1],
            FirstName: namesArray[0],
          },
        }
      })

      console.log("result== ", result)
      return {caseCount : getResponse.data.totalElements, result}
    } else {
      return {caseCount: 0, result: []}
    }
  } catch (error) {
    // 处理请求错误
    console.error("Request error:", error)
  }
}

// GET /{ver}/cases/{caseUuid}

export async function getCaseByUuid(
  uuid: string = "ba60bba5-3dd0-4d5f-aff7-62d006e7b3c7",
) {
  const meditClient = new HttpMedit() // 设置基础URL
  const grpUuid = await getMeditGroupUuid()
  const encodeduuid = encodeURIComponent(uuid);
 
  try {
    const getResponse = await meditClient.get(`/v1/cases/${encodeduuid}`, {
      headers: {
        "x-meditlink-client-id": "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo",
        "x-meditlink-group-uuid": `${grpUuid}`,
      },
    })
    console.log("GET getCaseByUuid data:", getResponse.data)
    return getResponse
  } catch (error) {
    // 处理请求错误
    console.error("Request getCaseByUuid error:", error)
  }

  return null;
}

export async function getFileUrl(
  file_id: string = "ba60bba5-3dd0-4d5f-aff7-62d006e7b3c7",
) {
  const meditClient = new HttpMedit() // 设置基础URL
  const grpUuid = await getMeditGroupUuid()
  const encodedFileId = encodeURIComponent(file_id)
  try {
    let jsonObj = JSON.parse(localStorage.getItem("meditData"))
    console.log("token=", localStorage.getItem("meditData"))
    const getResponse = await meditClient.get(`/v1/files/${encodedFileId}?type=stl`, {
      headers: {
        "x-meditlink-client-id": "PkpuC42YZcl2O5gJoaMEkG5owIOaKnMo",
        "x-meditlink-group-uuid": `${grpUuid}`,
      },
    })
    console.log("GET FIleURL data:", getResponse.data)
    return getResponse.data.url
  } catch (error) {
    // 处理请求错误
    console.error("Request error:", error)
  }
}

export async function downloadSTL(path?: string, name?: string, dispatch?: any) {
  // const response1 = await fetch(upStl)
  // const response2 = await fetch(lowStl)
  // const blob1 = await response1.blob()
  // const blob2 = await response2.blob()
  // return {
  //   upper: new File([blob1], "arch_u.stl", { type: "arch_u.stl" }),
  //   lower: new File([blob2], "arch_l.stl", { type: "arch_l.stl" }),
  // }

  const meditClient = new HttpMedit() // 设置基础URL

  try {
    dispatch && dispatch(setData({ loading: "pending" }))

    const blob = await meditClient.download7z(`${path}`)
    console.log(blob)

    const file = new File([blob], name, {
      type: blob.type || "application/octet-stream",
    })

    dispatch && dispatch(setData({ loading: "succeeded" }))
    return file
  } catch (error) {
    console.error("Request error:", error)
    dispatch && dispatch(setData({ loading: "failed" }))
    return null
  }
}